import React from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { validateAPEPDCLClient } from '../../../utils/helper';
import ChartBox from '../../Custom/ChartBox';
import AccumulatedEnergy from './AccumulatedEnergy';
import ActiveImpExpEnergy from './ActiveImpExpEnergy';
import ActivePowerVsTime from './ActivePowerVsTime';
import ApparentPowervsTime from './ApparentPowerVsTime';
import CurrentProfile from './CurrentProfile';
import EnergyProfile from './EnergyProfile';
import FrequencyDetailsChart from './FrequencyDetailsChart';
import PhasorDiagramChart from './PhasorDiagramChart';
import ReactiveImpExpEnergy from './ReactiveImpExpEnergy';
import ReactivePower from './ReactivePower';
import VoltageDetailsChartNew from './VoltageDetailsChartNew';

const style = {
  height: '52vh',
  overflow: 'auto',
};

class PowerQualityCharts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 1,
    };
  }

  render() {
    const { tab } = this.state;
    const { deviceId } = this.props;
    return (
      <Row>
        <Tabs
          defaultActiveKey={1}
          animation={true}
          id="noanim-tab-example"
          height="100px"
          onSelect={(key) => this.setState({ tab: key })}
          activeKey={tab}
        >
          <Tab eventKey={1} title={'V-I Profile'}>
            {tab === 1 && (
              <Col lg={12}>
                <Row style={style}>
                  {!validateAPEPDCLClient() && (
                    <ChartBox>
                      <PhasorDiagramChart deviceId={deviceId} />
                    </ChartBox>
                  )}
                  <ChartBox>
                    <VoltageDetailsChartNew
                      stateChanged={false}
                      deviceId={deviceId}
                      status={'predicted'}
                      selectedObj={null}
                    />
                  </ChartBox>
                  <ChartBox>
                    <CurrentProfile deviceId={deviceId} />
                  </ChartBox>
                  <ChartBox>
                    <FrequencyDetailsChart
                      deviceId={deviceId}
                      status={'predicted'}
                    />
                  </ChartBox>
                </Row>
              </Col>
            )}
          </Tab>
          <Tab eventKey={2} title={'Power Profile'}>
            {tab === 2 && (
              <Row style={style}>
                <ChartBox id={'rctvPowerChart'}>
                  <ReactivePower deviceId={deviceId} />
                </ChartBox>
                <ChartBox id={'apprntPowerChart'}>
                  <ApparentPowervsTime
                    deviceId={deviceId}
                    title={'Apparent Power Profile'}
                  />
                </ChartBox>
                <ChartBox id={'actvPwrChart'}>
                  <ActivePowerVsTime deviceId={deviceId} />
                </ChartBox>
              </Row>
            )}
          </Tab>
          <Tab eventKey={3} title={'Energy Profile'}>
            {tab === 3 && (
              <Row style={style}>
                {!validateAPEPDCLClient() && (
                  <ChartBox id={'accumulatedEnrgy'}>
                    <AccumulatedEnergy assetId={deviceId} />
                  </ChartBox>
                )}
                {!validateAPEPDCLClient() && (
                  <ChartBox>
                    <EnergyProfile assetId={deviceId} />
                  </ChartBox>
                )}
                <ChartBox>
                  <ActiveImpExpEnergy assetId={deviceId} />
                </ChartBox>
                <ChartBox>
                  <ReactiveImpExpEnergy assetId={deviceId} />
                </ChartBox>
              </Row>
            )}
          </Tab>
        </Tabs>
      </Row>
    );
  }
}
export default PowerQualityCharts;
